export const countrySelection = () => {
	const countrySelectionElement = document.getElementById('countrySelection')
	const form = document.getElementById('countryLanguageSelectionForm')

	// reset form on browser back button
	window.addEventListener('pageshow', function (event) {
		var historyTraversal = event.persisted ||
			(typeof window.performance != 'undefined' &&
				window.performance.navigation.type === 2)
		if (historyTraversal) {
			document.querySelector('form').reset()
		}
	})

	if (countrySelectionElement) {
		document.addEventListener('DOMContentLoaded', () => {
			countrySelectionElement.addEventListener('change', handleLanguageSelection)
		})

		form.addEventListener('submit', function (e) {
			e.preventDefault();
			redirectToLanguage(e.target);
		})

	}

	function handleLanguageSelection() {
		const e = document.getElementById('countrySelection')
		const option = e.options[e.selectedIndex]
		const langList = JSON.parse(option.dataset.lang_list)
		const langListArr = Object.keys(langList).map((key) => [key, langList[key]])

		if (langListArr.length > 0) {
			const languageSelection = document.getElementById('languageSelection')
			languageSelection.options
			removeOptions(languageSelection)
			addOptions(languageSelection, langListArr)
		}

	}

	function removeOptions(e) {
		while (e.firstChild) {
			e.removeChild(e.firstChild)
		}
	}

	function addOptions(e, oList) {
		for (var i = 0; i < oList.length; i++) {
			const element = oList[i]
			e.insertAdjacentHTML('beforeend', '<option value=\'' + element[0] + '\'>' + element[1] + '</option>')
		}
	}

  function redirectToLanguage(form) {
    const urlObject = new URL(window.location.href);
    const sanitizedLanguage = getLanguage(form).replace(/[^a-zA-Z0-9\-]/g, '');
    window.location.href = `${urlObject.origin}/${encodeURIComponent(sanitizedLanguage)}`;
  }

	function getLanguage(form) {

		const formData = new FormData(form)
		return Object.fromEntries(formData).languageSelection
	}

}
